module.exports = __webpack_public_path__ + "img/thumbnail_HoneyBadger_j_albino.25d14158.png";